import { defineMessages } from 'react-intl';

export default defineMessages({
  processing: {
    id: 'simulated.edition.LoaderAnswerSheet.processing',
    defaultMessage: 'Processing answer sheet files...',
  },
  pleaseWait: {
    id: 'simulated.edition.LoaderAnswerSheet.pleaseWait',
    defaultMessage: 'Please, wait!',
  },
});
